import React from 'react';

type SwitchProps = {
  /** The value to match against Case components */
  value: unknown;
  children: React.ReactNode;
};

type CaseProps = {
  /** When this value matches the Switch value, this case is rendered */
  when: unknown;
  children: React.ReactNode;
};

export function Case({ children }: CaseProps) {
  return <>{children}</>;
}

export function Switch({ value, children }: SwitchProps) {
  const childArray = React.Children.toArray(children);

  for (const child of childArray) {
    if (React.isValidElement(child) && child.type === Case) {
      const caseProps = child.props as CaseProps;
      if (Object.is(caseProps.when, value)) {
        return <>{caseProps.children}</>;
      }
    }
  }

  return null;
}
